import HTTP from '../../Infra/Http'

export const getPublicPlans = async () => {
  return await HTTP.Get('/api/plans/');
};

export const getPublicPlanDetail = async (id) => {
  return await HTTP.Get(`/api/plans/detail/${id}`);
};


export const gotoZarinpalGateway = async (basket) => {
  return await HTTP.Post('/api/plans/gateway/zarinpal',basket);
};



export const getInvoiceDetail = async (id) => {
  return await HTTP.Get(`/api/plans/invoice/${id}`);
};


export const getAllMyPayments = async () => {
  return await HTTP.Get('/api/plans/my-payments');
};
